import { Button, Result } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import ProtectedRoute from '../../routes/ProtectedRoute';

function GlobalNotFoundPage() {
    const userData = localStorage.getItem('userData');
    return (
        <div className='d-flex justify-content-center align-items-center flex-column gap-2'>
            {
                userData ? <>
                    <ProtectedRoute>
                        <Result
                            status="404"
                            title="404"
                            subTitle="The page you visited does not exist."
                            extra={<Button type="primary">
                                <Link to="/Dashboard">
                                    Dashboard
                                </Link>
                            </Button>}
                        />
                    </ProtectedRoute>
                </> : 
                <Result
                    status="404"
                    title="404"
                    subTitle="The page you visited does not exist."
                    extra={<Button type="primary">
                        <Link to="/Dashboard">
                            Dashboard
                        </Link>
                    </Button>}
                />
            }
        </div>
    )
}

export default GlobalNotFoundPage